import { PermissionEnum, UserPermissions } from '@creditsights/api-ui-web';
import { Icon, Loader } from '@creditsights/styleguide-web';
import { ReactElement, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { WEIGHTING_ICONS_MAP } from '../../Constants';
import useFetchAnalystCoverage from '../../hooks/company/useFetchAnalystCoverage';
import useFetchUserPermissions from '../../hooks/user/useFetchUserPermissions';
import { AnalystBioEvents } from '../../utils/trackUsage.utils';
import './AnalystCoverage.scss';

const canAccessResearch = (userPermissions?: UserPermissions) => userPermissions?.permissions.includes(PermissionEnum.RESEARCH);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function AnalystCoverage({ analystId, onNoCoverage, analystBioDataTracking }): ReactElement {
  const { data: coverage, isLoading } = useFetchAnalystCoverage(analystId);
  const { isLoading: permissionsLoading, data: userPermissions } = useFetchUserPermissions();
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    if (!isLoading && coverage?.length === 0) {
      onNoCoverage();
    }
  }, [coverage, isLoading]);

  const renderWeight = (issuer) => {
    if (!canAccessResearch(userPermissions) || !issuer.csCoverage) {
      return null;
    }

    const weighting = issuer?.latestRec?.weighting;
    return (
      <div className="weight">
        <Icon name={WEIGHTING_ICONS_MAP[weighting?.toLowerCase()]} height={30} width={30} />
      </div>
    );
  };

  const fetchCompanies = () => {
    if (expand) {
      return coverage;
    }
    return coverage?.slice(0, 10);
  };

  const coverageCompanyClickHandler = (coverageIssuer: string) => {
    analystBioDataTracking({ event: AnalystBioEvents.ANALYST_BIO_COVERAGE_ISSUER_NAVIGATION, coverageIssuer });
  };

  if (isLoading || permissionsLoading) {
    return <Loader className="cs-loader" position="center" />;
  }
  return (
    <div className="cs-analyst-coverage-ctx">
      <div className="title">Coverage</div>
      <div className="company-list">
        {fetchCompanies()?.map((item) => (
          <NavLink to={`/companies/${item.tagId.replace('company/', '')}`} key={item.tagId} className="company" onClick={() => coverageCompanyClickHandler(item.displayName)}>
            {renderWeight(item)}
            <div className="name">{item.displayName}</div>
          </NavLink>
        ))}
      </div>
      {coverage && coverage.length > 10 && (
        <div className="show-more" onClick={() => setExpand((p) => !p)}>
          Show {expand ? 'Less' : 'More'}
        </div>
      )}
    </div>
  );
}

export default AnalystCoverage;
